<template>
    <div class="modal-mask" @click.self="close()">
        <div class="modal-content">
            <slot name="modal-title" />
            <slot name="content" />
            <slot name="controls" />
        </div>
    </div>
</template>
<script>
export default {
	methods: {
		close () {
			this.$emit('close')
		}
	}
}
</script>
<style lang="scss" scoped>
.modal-mask {
    position: fixed !important;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: #00000029;
    z-index: +99;
    overflow: auto;
    width: 100vw;
    height: 100vh;
    display: flex;
    padding: 50px 0;

    .modal-content {
        background-color: #fff;
        padding: 10px;
        border-radius: 5px;
        color: #575B5C;
        box-shadow: 0 0 3px #00000029;
        margin: auto;

        .modal-title {
            font-size: 16px;
            font-weight: 700;
            padding: 10px;
            box-shadow: 0 1px 0#00000029;
        }

        .content {
            padding: 10px;
        }

        .controls {
            padding: 10px;
            display: flex;
            justify-content: flex-end;

            button {
                width: 133px;
                height: 40px;
                padding: 5px;
                margin-left: 10px;
            }

            &.column {
                flex-direction: column;

                button {
                    width: 100%;
                    margin-bottom: 20px;
                    margin-left: 0;
                }
            }
        }
    }

    &.report-modal {

        .modal-content {
            width: 450px;

            .modal-title {
                color: #575B5C;
            }

            .content {
                > * {
                    margin-bottom: 20px;
                }

                .group {
                    display: flex;
                    justify-content: space-between;

                    .box{
                        width: 190px;

                        &:first-child {
                            margin-right: 50px;
                        }
                    }
                }
            }
        }
    }
}
</style>
